<div class="documents-list">
    <div [ngClass]="{ disabled: disabled }">
        <span
            style="margin-top: 4px"
            hamIconShapes
            icon="assets/hamIcons/plus-outline.svg"
            [variant]="'gray'"
            [size]="'m'"
            [type]="'circle'"
            (click)="openUploadDocumentDialog()"
            [disabled]="disabled"
        ></span>
    </div>

    <div *ngFor="let doc of visibleDocumentsInProgress" class="document-entry" [ngClass]="{ disabled: disabled }">
        <mat-progress-spinner [diameter]="20" mode="indeterminate"></mat-progress-spinner>
        <div class="document-name-date">
            <span class="name">{{ doc }}</span>
        </div>
    </div>
    <div
        #documentContainer
        *ngFor="let document of visibleDocuments"
        class="document-container"
        (click)="showPreview(document, documentContainer)"
        (mouseenter)="onMouseEnter(document, documentContainer)"
        (mouseleave)="onMouseLeave()"
    >
        <div class="document-entry" [ngClass]="{ disabled: disabled, active: document.id === hoveredDocument?.id }">
            <span class="extension-icon-wrapper">
                <span
                    *ngIf="document.extension === 'link'"
                    class="extension-icon"
                    hamIconShapes
                    icon="assets/hamIcons/link.svg"
                    [size]="'20px'"
                    [variant]="'transparent'"
                    (click)="openExternalLink(document)"
                    hamTooltip="{{ 'aumico_app_cpmm_documents_open_link' | i18next }}"
                    [withArrow]="true"
                    [backGroundHexColor]="'#1F2A37'"
                    [tooltipClass]="'cpmm-flex'"
                ></span>
                <span
                    *ngIf="document.extension === 'pdf'"
                    class="extension-icon"
                    hamIconShapes
                    icon="assets/hamIcons/pdf.svg"
                    [size]="'20px'"
                    [variant]="'transparent'"
                ></span>
                <span
                    *ngIf="document.extension === 'xlsx'"
                    class="extension-icon"
                    hamIconShapes
                    icon="assets/hamIcons/excel.svg"
                    [size]="'20px'"
                    [variant]="'transparent'"
                ></span>
                <span
                    *ngIf="document.extension === 'docx'"
                    class="extension-icon"
                    hamIconShapes
                    icon="assets/hamIcons/word.svg"
                    [size]="'20px'"
                    [variant]="'transparent'"
                ></span>
                <span
                    *ngIf="
                        document.extension === 'jpg' || document.extension === 'png' || document.extension === 'jpeg'
                    "
                    class="extension-icon"
                    hamIconShapes
                    icon="assets/hamIcons/image.svg"
                    [size]="'20px'"
                    [variant]="'transparent'"
                ></span>
            </span>
            <span
                *ngIf="document.isPermanent"
                class="permanent-file-icon-wrapper"
                hamTooltip="{{ 'aumico_app_cpmm_documents_is_permanent_tooltip' | i18next }}"
                [withArrow]="true"
                [backGroundHexColor]="'#1F2A37'"
                [tooltipClass]="'cpmm-flex'"
            >
                <span
                    class="pin-icon"
                    hamIconShapes
                    icon="assets/hamIcons/pin.svg"
                    [size]="'20px'"
                    [variant]="'transparent'"
                ></span>
            </span>
            <span
                *ngIf="isExpireDateAlarming(document.expiryDate)"
                class="expiration-file-icon-wrapper"
                [hamTooltip]="
                    document.isExpired
                        ? ('aumico_ui_document_has_expired' | i18next) + ' ' + (document.expiryDate | date)
                        : ('aumico_ui_document_about_to_expire' | i18next) + ' ' + (document.expiryDate | date)
                "
                [withArrow]="true"
                [backGroundHexColor]="'#1F2A37'"
                [tooltipClass]="'cpmm-flex'"
            >
                <span
                    class="exclamation-outline-icon"
                    hamIconShapes
                    icon="assets/hamIcons/exclamation-outline.svg"
                    [size]="'20px'"
                    [variant]="'transparent'"
                ></span>
            </span>
            <div class="document-name-date">
                <span class="name">{{ document.name }} </span>
                <!--  <span class="date-annotation">{{
                    document.createdAt | dateTimeLocale : null : null : true : false
                }}</span>-->
            </div>
        </div>

        <!-- Edit/Remove Icons Overlay - Only visible when hovered -->
        <div class="action-icons-overlay" *ngIf="document.id === hoveredDocument?.id && !disabled">
            <span
                *ngIf="document.taskId == taskId"
                class="icon pen-icon"
                hamIconShapes
                icon="assets/hamIcons/pen-outline.svg"
                [variant]="'transparent'"
                [size]="'regular'"
                [type]="'circle'"
                (click)="editDocumentStart(document)"
            ></span>
            <span
                class="icon remove-icon"
                hamIconShapes
                icon="assets/hamIcons/trash-outline.svg"
                [variant]="'transparent'"
                [size]="'regular'"
                [type]="'circle'"
                (click)="removeDocument(document)"
            ></span>
        </div>

        <div
            class="preview-flyout"
            *ngIf="document.id === previewDocument?.id"
            [ngStyle]="{
                position: 'fixed',
                top: '50%',
                left: flyoutPosition.left + 'px',
                transform: 'translateY(-50%)'
            }"
            [class.fading-out]="!!leaveTimer"
        >
            <div class="flyout-preview-content">
                <!-- External Link Preview -->
                <ng-container *ngIf="document.extension === 'link' && document.externalLinkUrl; else filePreview">
                    <div class="link-preview">
                        <div class="link-icon">
                            <span
                                hamIconShapes
                                icon="assets/hamIcons/link.svg"
                                [size]="'48px'"
                                [variant]="'transparent'"
                            ></span>
                        </div>
                        <div class="link-info">
                            <div class="link-title">{{ document.name }}</div>
                            <div class="link-url">{{ document.externalLinkUrl }}</div>
                        </div>
                    </div>
                    <div class="flyout-buttons">
                        <ham-button size="sm" (click)="openExternalLink(document)">{{
                            'aumico_app_cpmm_documents_open_link' | i18next
                        }}</ham-button>
                    </div>
                </ng-container>

                <!-- File Preview -->
                <ng-template #filePreview>
                    <ng-container *ngIf="document.previewUrl; else noPreview">
                        <img
                            [src]="document.previewUrl"
                            alt="Document Preview"
                            class="preview-image"
                            (error)="handlePreviewImageError(document)"
                        />
                        <div class="flyout-buttons">
                            <ham-button size="sm" (click)="downloadDocument(document)">{{
                                'aumico_app_cpmm_documents_download' | i18next
                            }}</ham-button>
                            <ham-button
                                size="sm"
                                (click)="openDocument(document)"
                                *ngIf="
                                    document.extension === 'pdf' ||
                                    document.extension === 'jpg' ||
                                    document.extension === 'png' ||
                                    document.extension === 'jpeg'
                                "
                                >{{ 'aumico_app_cpmm_documents_open' | i18next }}</ham-button
                            >
                        </div>
                    </ng-container>
                    <ng-template #noPreview>
                        <div class="no-preview-message">
                            <span>{{ getPreviewStatusText(document.previewStatus) }}</span>
                        </div>
                        <div
                            *ngIf="document.previewStatus !== 'not_started' && document.previewStatus != 'scanning'"
                            class="flyout-buttons"
                        >
                            <ham-button size="sm" (click)="downloadDocument(document)">{{
                                'aumico_app_cpmm_documents_download' | i18next
                            }}</ham-button>
                            <ham-button
                                size="sm"
                                (click)="openDocument(document)"
                                *ngIf="
                                    document.extension === 'pdf' ||
                                    document.extension === 'jpg' ||
                                    document.extension === 'png' ||
                                    document.extension === 'jpeg'
                                "
                                >{{ 'aumico_app_cpmm_documents_open' | i18next }}</ham-button
                            >
                        </div>
                    </ng-template>
                </ng-template>
            </div>
        </div>
    </div>

    <span class="showAllText" *ngIf="documents.length > 3 && !showAll" (click)="showAll = true">{{
        'aumico_ui_view_all' | i18next
    }}</span>
    <span class="showAllText" *ngIf="documents.length > 3 && showAll" (click)="showAll = false">{{
        'aumico_ui_view_less' | i18next
    }}</span>
</div>

<div class="upload-modal" *ngIf="showUploadModal">
    <ham-document-form
        [acceptedExtensions]="acceptedExtensions"
        [maxSizeInMb]="10"
        (documentSubmit)="onDocumentSubmit($event)"
        (onCancel)="onCancelUpload()"
        [document]="documentToEdit"
    >
    </ham-document-form>
</div>

<ham-confirm-decline-modal
    *ngIf="showDeleteModal"
    (cancel)="onCancelDelete()"
    (action)="onConfirmDelete()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_button_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_app_cpmm_documents_delete_confirmation' | i18next : { documentName: documentToDelete?.name }"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
